<mat-card *ngIf="stats" class="backspace cursor title">
    <mat-card-title class="statsbg">My Stats</mat-card-title>
    <!-- <img mat-card-avatar *ngIf="stats.statsMonth.realtor" class="realtor" [src]="stats.statsMonth.realtor | realtor"
        [matTooltip]="stats.statsMonth.realtor | realtorName" /> -->
    <mat-list class="h">
        <mat-list-item>
            <mat-icon matListIcon class="hot">{{GLOBAL.ICONS.DOLLAR}}</mat-icon>
            <h3 matLine><b> {{stats.statsYear.sales?.all || 0 | number}}</b> </h3>
        </mat-list-item>
        <mat-list-item>
            <mat-icon matListIcon [ngClass]="{active:stats.statsMonth.sales?.all}">{{GLOBAL.ICONS.DOLLAR}}</mat-icon>
            <h3 matLine> {{stats.statsMonth.sales?.all || 0 | number}} </h3>
        </mat-list-item>
        <mat-list-item>
            <mat-icon matListIcon [ngClass]="{active:stats.statsMonth.nbDeals?.all}">{{GLOBAL.ICONS.DEAL}}</mat-icon>
            <h3 matLine> {{stats.statsMonth.nbDeals?.all || 0}} </h3>
        </mat-list-item>
    </mat-list>
    <mat-list class="h">
        <mat-list-item>
            <mat-icon matListIcon>{{GLOBAL.ICONS.MANDATEADD}}</mat-icon>
            <h3 matLine> {{stats.statsMonth.mandateOrigins?.all || 0}} </h3>
        </mat-list-item>
        <mat-list-item>
            <mat-icon matListIcon>{{GLOBAL.ICONS.NEWREQUEST}}</mat-icon>
            <h3 matLine> {{stats.statsMonth.projectOrigins?.all || 0}} </h3>
        </mat-list-item>
        <mat-list-item>
            <mat-icon matListIcon>{{GLOBAL.ICONS.VISIT}}</mat-icon>
            <h3 matLine> {{stats.statsMonth.actions?.visit || 0}} </h3>
        </mat-list-item>
    </mat-list>
</mat-card>